export class BlockNotFoundError extends Error {
	constructor(blockId: string) {
		super(`Block not found: ${blockId}`);
		this.name = 'BlockNotFoundError';
	}
}

export function isBlockNotFoundError(error: unknown): error is BlockNotFoundError {
	return error instanceof BlockNotFoundError;
}
